import * as React from 'react';
import * as I18n from 'i18n-js';
import HomepageMarketingCallout from './homepage_marketing_callout';
import NewsletterSignup from '@reverbdotcom/commons/dist/components/newsletter_signup';

interface IProps {
  signupReason: string;
}

export default function HomepageNewsletter({ signupReason }: IProps) {
  const backgroundImage = 'https://reverb-res.cloudinary.com/image/upload/v1591215984/20200424-Email-Callout_tcf6w4.jpg';

  return (
    <HomepageMarketingCallout
      imageUrl={backgroundImage}
    >
      <NewsletterSignup
        title={I18n.t('discovery.newsletterSignup.title')}
        subtitle={I18n.t('discovery.newsletterSignup.subtitle')}
        signupReason={signupReason}
      />
    </HomepageMarketingCallout>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_newsletter.tsx